// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let SubusersPageAccountsListItem = require("./SubusersPageAccountsListItem.bs.js");
let SubusersPageAccountsList_account_graphql = require("../../__generated__/SubusersPageAccountsList_account_graphql.bs.js");

let getConnectionNodes = SubusersPageAccountsList_account_graphql.Utils.getConnectionNodes;

let convertFragment = SubusersPageAccountsList_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersPageAccountsList_account_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersPageAccountsList_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SubusersPageAccountsList_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubusersPageAccountsList_account_graphql.node, convertFragment, fRef);
}

let AccountFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function SubusersPageAccountsList(props) {
  let currentUserRole = props.currentUserRole;
  let account = RescriptRelay_Fragment.useFragment(SubusersPageAccountsList_account_graphql.node, convertFragment, props.account);
  let members = getConnectionNodes(account.members);
  return JsxRuntime.jsx("div", {
    children: members.map((member, index) => JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(SubusersPageAccountsListItem.make, {
        member: member.fragmentRefs,
        account: account.fragmentRefs,
        currentUserRole: currentUserRole
      })
    }, index.toString()))
  });
}

let make = SubusersPageAccountsList;

exports.AccountFragment = AccountFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
